<template>
  <div id="content">
    <div id="pageContent">
      <div class="pageHeader">
        <div
          class="white flex flex-column hcenter"
          style="font-family: TruenoBd;padding-left: 10%;height: 100%"
        >
          <div class="pageTitle">加入一兮</div>
          <div class="subPageTitle">/COMPANY DYNAMICS</div>
        </div>
      </div>
      <section>
        <a id="company" class="title t-center">在招职位</a>
        <div class="info">简历投递邮箱：hr@yixilife.com</div>
        <div class="info">
          邮件及简历命名格式：应聘岗位+工作年限+最高学历+姓名
        </div>
        <div class="mt4 work-tab flex vcenter hcenter">
          <div v-for="(item, index) of works" :key="index">
            <div class="work mr2 mb2 flex flex-column justify-spaceBetween">
              <div>
                <div class="work-title">{{ item.name }}</div>
                <div class="desc my2">
                  <span class="mr2">{{ item.money }}</span
                  >{{ item.description }}
                </div>
              </div>
              <div class="flex justify-spaceBetween vcenter">
                <div class="date">{{ item.date }}</div>
                <div class="arrow-border pointer" @click="goDetail(item.url)">
                  <div class="arrow"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Join",
  data() {
    return {
      works: [
        {
          date: "2022-04-30",
          description: "黄山，1年经验，本科",
          id: "1",
          money: "5-10万/年",
          name: "纯化（助理）工程师",
          url:
            "https://jobs.51job.com/huangshan/139735431.html?s=sou_sou_soulb&t=0_0",
          welf: "五险一金，工作餐，可提供宿舍，绩效奖金，不定期福利，加班费"
        }
      ]
    };
  },
  mounted() {
    this.getjobList();
  },
  methods: {
    // go(name) {
    //   var scrollTop = document.getElementById(name).scrollTop;
    // }
    goDetail(url) {
      window.open(url, "_blank");
    },
    async getjobList() {
      let res = await request({
        url: `/api.php?app=ajax&app_act=jobList`,
        method: "get"
      });
      this.works = res.data ? res.data.data : [];
      // this.newsList.forEach(item => {
      //   item.article_pic_big = require(`${item.article_pic_big}`);
      // })
    }
  }
};
</script>

<style lang="scss" scoped>
.pageHeader {
  overflow: hidden;
  width: 100%;
  height: 494px;
  background-image: url("../assets/join/join1.png");
  background-position: 70% 50%;
}
.title {
  display: block;
  font-size: 32px;
  font-weight: 600;
  color: #111d2b;
  line-height: 1;
  margin-bottom: 16px;
}
.info {
  color: #111d2b;
  opacity: 0.5;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
}
.work-tab {
  flex-wrap: wrap;
}
.work {
  width: 400px;
  height: 300px;
  background: #ffffff;
  box-shadow: 0px 0px 27px 0px rgba(17, 29, 43, 0.16);
  border-radius: 11px;
  padding: 43px;
  .work-title {
    color: #00bd89;
    font-weight: 500;
    font-size: 22px;
  }
  .desc {
    max-height: 135px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 5;
    font-size: 14px;
    color: rgba(17, 29, 43, 0.5);
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .date {
    font-size: 24px;
    font-weight: 400;
    color: rgba(17, 29, 43, 0.2);
  }
}
.work:hover {
  background: #f5fbf9;
  .date {
    color: #00bd89;
  }
  .arrow-border {
    background: #00bd89;
    .arrow {
      background: url("../assets/join/arrow2.svg") 50% 50% no-repeat no-repeat;
    }
  }
}
.arrow-border {
  width: 88px;
  height: 35px;
  border: 1px solid rgba(17, 29, 43, 0.14);
  padding: 7px;
  .arrow {
    background: url("../assets/join/arrow.svg") 50% 50% no-repeat no-repeat;
    height: 100%;
  }
}
@media screen and (max-width: 640px) {
  .work {
    width: 100%;
    height: 250px;
    .work-title {
      color: #00bd89;
      font-weight: 500;
      font-size: 22px;
    }
    .desc {
      -webkit-line-clamp: 3;
      font-size: 16px;
      width: 250px;
      word-break: break-all;
    }
    .date {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/join.vue